import React from "react";
import { Navigate } from "react-router-dom";
import { useCustomerAuth } from "@/context/CustomerAuthContext";

export default function CustomerProtectedRoute({ children }) {
  const { customer, loading } = useCustomerAuth();
  if (loading) {
    return (
      <div className="min-h-screen flex items-center justify-center bg-[var(--bg)] text-[#c9a86a]">
        <div className="animate-pulse tracking-[0.3em] text-sm">LE COLLECTIF HORLOGER</div>
      </div>
    );
  }
  if (!customer) return <Navigate to="/account/login" replace />;
  return children;
}
